import { DROP_ADD_MORE_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[DROP_ADD_MORE_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Add More',
	},
}
